(() => {
  const root = window.Shopify?.routes?.root || '/';
  const toast = document.getElementById('cart-toast');
  let toastTimer;
  const notify = (text, link) => {
    if (!toast) return;
    toast.replaceChildren(document.createTextNode(text));
    if (link) { const a = document.createElement('a'); a.href = root + 'cart'; a.textContent = link; toast.append(a); }
    toast.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { toast.hidden = true; }, 7000);
  };
  document.addEventListener('change', event => {
    const select = event.target.closest('[data-variant-select]');
    if (!select) return;
    const card = select.closest('[data-product-card]');
    const option = select.selectedOptions[0];
    card.querySelector('[data-price]').textContent = option.dataset.price || '';
    if (option.dataset.image) {
      const image = card.querySelector('.product-image img');
      if (image) { image.removeAttribute('srcset'); image.src = option.dataset.image; }
    }
  });
  document.addEventListener('submit', async event => {
    const form = event.target.closest('.product-form');
    if (!form || !window.fetch) return;
    const select = form.querySelector('[name="id"]');
    if (!select) return;
    event.preventDefault();
    const message = form.querySelector('.form-message');
    if (!select.value) { select.focus(); select.reportValidity(); return; }
    const button = form.querySelector('[data-add]');
    if (button.disabled) return;
    const label = button.textContent; button.disabled = true; form.setAttribute('aria-busy','true'); message.textContent = '';
    try {
      const response = await fetch(root + 'cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'Unable to add this item. Please try again.');
      notify(window.UWText?.added || 'Added to bag', window.UWText?.viewBag || 'View bag');
      try { const cartResponse = await fetch(root + 'cart.js', {headers:{Accept:'application/json'}}); if(cartResponse.ok) { const cart = await cartResponse.json(); document.querySelectorAll('[data-cart-count]').forEach(el => { el.textContent = cart.item_count; }); } } catch (_) {}
    } catch (error) { message.textContent = error.message; }
    finally { button.disabled = false; button.textContent = label; form.removeAttribute('aria-busy'); }
  });
  document.addEventListener('click', async event => {
    const link = event.target.closest('[data-load-more]');
    if (!link || !window.fetch) return;
    event.preventDefault();
    if (link.getAttribute('aria-busy') === 'true') return;
    link.setAttribute('aria-busy','true');
    try {
      const response = await fetch(link.href);
      if(!response.ok) throw new Error('catalog');
      const page = new DOMParser().parseFromString(await response.text(),'text/html');
      const grid = document.querySelector('[data-product-grid]');
      const nextGrid = page.querySelector('[data-product-grid]');
      const nextPagination = page.querySelector('[data-pagination]');
      if (!nextGrid || !nextPagination) throw new Error('catalog');
      const first = nextGrid.querySelector('a');
      [...nextGrid.children].forEach(card => grid.append(card));
      document.querySelector('[data-pagination]').replaceChildren(...nextPagination.childNodes);
      if(first) { first.focus({preventScroll:true}); }
    } catch (_) { window.location.assign(link.href); }
  });
})();
